import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap, TimelineMax} from "gsap";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {TrueGritScatterSymbol} from "../../reels/TrueGritScatterSymbol";

// #295
export class TrueGritPlusFSRunner implements SimplePresentation {

    public shouldRun(): boolean {
        const mode: string = TrueGrit.model.data.mode,
            nextMode: string = TrueGrit.model.data.nextMode;

        return (mode === TrueGritGameMode.NORMAL || mode === TrueGritGameMode.NORMAL_AVALANCHE)
            && (nextMode === TrueGritGameMode.FREESPIN || nextMode === TrueGritGameMode.FREESPIN_SUPER);
    }

    public start(controller: SimplePresentationRunnerController): void {
        const mainTL: TimelineMax = gsap.timeline({onComplete: () => controller.finish()});

        TrueGrit.trueGritScatterSymbols.getAllUsedScatters().forEach((sym: TrueGritScatterSymbol) => {
            mainTL.add(sym.playPlusFSAnimation(false), 0);
        });
    }
}